// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__OpA8f","title":"styles_title__1VlLx","events":"styles_events__HM4zx"};